import { render, staticRenderFns } from "./ResourcesListHorizontal.vue?vue&type=template&id=3f067352&scoped=true"
import script from "./ResourcesListHorizontal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourcesListHorizontal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ResourcesListHorizontal.vue?vue&type=style&index=0&id=3f067352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f067352",
  null
  
)

export default component.exports